import Vue from 'vue';
import { SlotsMixin } from './mixins/slots';
import { ListenersMixin } from './mixins/listeners';
export function nextTick() {
  return new Promise(Vue.nextTick);
}
export function mergeSlots(context) {
  var _ref, _context$scopedSlots;
  var scopedSlots = (_ref = (_context$scopedSlots = context.scopedSlots) != null ? _context$scopedSlots : context.data.scopedSlots) != null ? _ref : {};
  var slots = context.slots();
  Object.keys(slots).forEach(key => {
    if (!scopedSlots[key]) {
      scopedSlots[key] = () => slots[key];
    }
  });
  return scopedSlots;
}
export function defineComponent(sfc) {
  if (sfc.mixins) {
    sfc.mixins.push(SlotsMixin);
    sfc.mixins.push(ListenersMixin);
  } else {
    sfc.mixins = [SlotsMixin, ListenersMixin];
  }
  return sfc;
}